<template>
  <div>
    <div class="header">
      <div class="header-container">
        <div class="logo-container-move"></div>
        <div class="logo-container">
          <img
            src="https://res.hc-cdn.com/CDN-Static-new/1.1.1114/hws/node_modules/@cube/cf-theme/hws/theme/hws/images/zh-logo.2239.2239c798.svg">
        </div>
        <div class="logo-container-split"></div>
        <div class="system-name-container">
          <h2 class="system-name">{{$t('system_name')}}</h2>
        </div>

        <div class="i18n-switch">
          <span class="buttons" v-for="item in i18nSet" :key="item" @click="changeI18n(item)">{{item}}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content-container">
        <br><br>
        <div class="domain-input-container">
          <div class="domain-input">
            <el-input
              placeholder="www.huaweicloud.com"
              v-model="detectDomain"
              @keyup.enter.native="resolveDomain"
              clearable>
              <i slot="suffix" class="el-input__icon el-icon-search" @click="resolveDomain"></i>
            </el-input>
          </div>
          <div class="domain-input-button">
            <el-button type="primary" @click="resolveDomain">{{$t('system_check_button')}}</el-button>
          </div>
        </div>
        <br>
        <div class="content-inner-container">
          <div class="inner-header"><div class="inner-header-content">{{$t('ip_info')}} </div></div>
          <br>
          <div class="inner-content">
            <span class="inner-content-left"> {{$t('local_ip')}} </span>
            <span class="inner-content-right"> {{clientIp}} {{clientIpInfo}}</span>
          </div>
          <div class="inner-content">
            <span class="inner-content-left"> {{$t('local_dns')}} </span>
            <span class="inner-content-right"> {{localDNSIp}} {{localDNSInfo}}</span>
          </div>
          <br>
        </div>
        <div class="content-inner-container" v-if="existDomain">
          <div class="inner-header"><div class="inner-header-content">{{$t('probe_sever_info')}} </div></div>
          <br>
          <div class="inner-content">
            <span class="inner-content-left"> {{$t('domain_name')}}</span>
            <span class="inner-content-right"> {{detectDomain}} </span>
          </div>
          <div class="inner-content">
            <span class="inner-content-left"> {{$t('recommend_resolution_ip')}}</span>
            <span class="inner-content-right" v-if="recommendResolveIps"> {{recommendResolveIps}} </span>
          </div>
          <div class="inner-content">
            <span class="inner-content-left"> {{$t('status_code')}}</span>
            <span class="inner-content-right" v-if="httpStatus"> {{httpStatus}} </span>
          </div>
          <div class="inner-content">
            <span class="inner-content-left"> {{$t('network_delay')}}</span>
            <span class="inner-content-right" v-if="netDelay"> {{netDelay}}&nbsp;<a
              v-if="netDelay !== 'error'">ms</a></span>
          </div>
          <div class="inner-content">
            <span class="inner-content-left"> {{$t('download_speed')}}</span>
            <span class="inner-content-right" v-if="downloadSpeed"> {{downloadSpeed}}&nbsp;<a
              v-if="downloadSpeed !== 'error'">kb/s</a></span>
          </div>
          <br>
        </div>
        <div class="content-inner-container">
          <div class="inner-header"><div class="inner-header-content"> {{$t('system_environment_information')}} </div></div>
          <br>
          <div class="inner-content">
            <span class="inner-content-left"> {{$t('time')}} </span>
            <span class="inner-content-right"> {{nowDate}}&nbsp;{{nowTime}}</span>
          </div>
          <div class="inner-content">
            <span class="inner-content-left"> User Agent: </span>
            <span class="inner-content-right"> {{userAgent}} </span>
          </div>
          <br>
        </div>
        <br>
      </div>
    </div>
    <footer class="foot">
      <div class="copyright-container">{{$t('footer_copyright')}}</div>
    </footer>
  </div>
</template>

<script>
import axios from 'axios'

  export default {
    name: 'Main',
    data() {
      return {
        name: 'CDN用户诊断系统',
        httpsProtocol: "https://",
        httpProtocol: "http://",
        httpsPort: "443",
        httpPort: "80",
        domain: "dns-detect-portal.n.cdnhwc5.cn",
        downloadDomain: "hw-1.stat.nanguapi.com",
        resolveDomainURI: "/api/resolve_ip",
        getRandomDomainURI: "/api/generate_url",
        getIpInfoURI: "/api/detect_local",
        checkStatusURI: "/nodeStatus",
        downloadTestURI: "/boce.txt",
        downloadFileSize: 1608390,
        nowTime: new Date().toLocaleTimeString(),
        nowDate: new Date().toLocaleDateString(),
        userAgent: navigator.userAgent,
        detectDomain: null,
        recommendResolveIps: "loading",
        clientIp: "loading",
        clientIpInfo: null,
        localDNSIp: "loading",
        localDNSInfo: null,
        existDomain: false,
        httpStatus: "loading",
        netDelay: "loading",
        downloadSpeed: "loading",
        i18n: 'zh-cn',
        i18nSet: ['中文', 'en'],
      }
    },
    methods: {
      changeI18n(val) {
        console.log(this)
        // this.i18n = this.i18n === 'zh-cn' ? 'en' : 'zh-cn';
        if (val) {
          // this.$i18n.locale = val;
          console.log(val)
          this.$i18n.locale = this.$i18n.locale === 'en' ? 'zh' : 'en';
          return;
        }
        // this.$i18n.locale = this.$i18n.locale === 'zh' ? 'zh' : 'en';
      },
      // isLocale(key) {
      //   return this.i18n === 'zh-cn' ? ZH[key] : EN[key];
      // },
      isNotBlankString(str) {
        return !(typeof str == "undefined" || str == null || str === "")
      },
      jsonp(url){
        return new Promise((resolve,reject) => {
          let JSONP=document.createElement("iframe");
          JSONP.src=`${url}`;
          document.getElementsByTagName("head")[0].appendChild(JSONP);
          setTimeout(() => {
            document.getElementsByTagName("head")[0].removeChild(JSONP)
          },1000000)
          JSONP.onload = resolve
          JSONP.onerror = reject
        })
      },
      getDownLoadSpeed(ip) {
        localStorage.clear()
        let url = this.httpProtocol + ip + "/" + this.downloadDomain + this.downloadTestURI
        let start = new Date().getTime();
        this.jsonp(url)
          .then(response => {
            let end = new Date().getTime();
            let time = end - start;
            this.downloadSpeed = Math.round(this.downloadFileSize / time)
          }).catch(error => {
          this.downloadSpeed = 'error'
        })
      },
      getNetDelay(ip) {
        let url = this.httpProtocol + ip + "/" + this.downloadDomain + this.checkStatusURI
        let total = 0
        for (let i = 0; i < 5; i++) {
          let start = new Date().getTime();
          axios
            .get(url)
            .then(response => {
              let end = new Date().getTime();
              total = total + (end - start)
              if (i === 4) {
                this.netDelay = total / 5
                this.httpStatus = response.status
              }
            })
            .catch(error => {
              this.netDelay = "error"
              if (this.isNotBlankString(error.response)) {
                this.httpStatus = error.response.status
              }else {
                this.httpStatus = "error"
              }
            })
        }
      },
      resolveDomain() {
        this.existDomain = this.isNotBlankString(this.detectDomain);
        this.detectDomain = this.detectDomain.replace(/\s+/g,"")
        const domainCheck = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
        if (!domainCheck.test(this.detectDomain)){
          this.$message(`非法域名`)
          this.detectDomain = null
          this.existDomain = false
        }
        if (this.existDomain) {
          this.$route.query.domain=this.detectDomain
          let url = this.httpProtocol + this.domain + ":" + this.httpPort + this.resolveDomainURI
            + "?domain=" + this.detectDomain + "&local="
          axios
            .get(url)
            .then(response => {
              let recommendIps = response.data.hwcloud
              this.LDNSResolveIps = "error"
              this.recommendResolveIps = "error"
              if (recommendIps instanceof Array) {
                this.recommendResolveIps = recommendIps.join(" ")
                this.getNetDelay(recommendIps[0])
                this.getDownLoadSpeed(recommendIps[0])
              }else {
                if (this.isNotBlankString(response.status)) {
                  this.httpStatus = response.status
                }else {
                  this.httpStatus = "error"
                }
                this.downloadSpeed = 'error'
                this.netDelay = "error"
              }
            })
            .catch(error => {
              if (this.isNotBlankString(error.response)) {
                this.httpStatus = error.response.status
              }else {
                this.httpStatus = "error"
              }
              this.downloadSpeed = 'error'
              this.netDelay = "error"
              this.recommendResolveIps = "error"
            })
        }
      },
      getRandomDomain(callback) {
        let url = this.httpProtocol + this.domain + ":" + this.httpPort + this.getRandomDomainURI
        axios
          .get(url)
          .then(response => {
            callback(response.data.domain)
          })
          .catch(error => {
            this.clientIp = "error"
            this.localDNSIp = "error"
          })
      },
      getIpInfo(domain) {
        let url = this.httpProtocol + domain + ":" + this.httpPort + this.getIpInfoURI
        axios
          .get(url)
          .then(response => {
            let client = response.data.client
            let localDNS = response.data.local
            this.clientIp = client.ip
            this.clientIpInfo = "(" + client.loc.isp + " " + client.loc.country + " " + client.loc.region + " " + client.loc.city + ")"
            this.localDNSIp = localDNS.ip
            this.localDNSInfo = "(" + localDNS.loc.isp + " " + localDNS.loc.country + " " + localDNS.loc.region + " " + localDNS.loc.city + ")"
          })
          .catch(error => {
            this.clientIp = "error"
            this.localDNSIp = "error"
          })
      }
    },
    mounted() {
      this.detectDomain = this.$route.query.domain
      this.getRandomDomain(this.getIpInfo)
      this.resolveDomain()
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo-container-move {
    display: inline-block;
    width: 1px;
    height: 1px;
  }

  .logo-container-split {
    display: inline-block;
    width: 5px;
  }

  .logo-container {
    display: inline-block;
    padding-left: 10px;
    float: left;
    background-size: cover;
    line-height: 2.6%
  }

  .header-container {
    text-align: left;
    box-sizing: border-box;
    height: 50px;
    background-color: rgb(40, 43, 51);
  }

  .header-logo img {
    display: inline-block;
    vertical-align: middle;
    height: 2.5%;
  }

  .system-name {
    margin-top: 12px;
    color: #dadfe7;
  }

  .system-name-container {
    display: inline-block;
  }

  .i18n-switch {
    float: right;
    width: 100px;
    height: 100%;
    line-height: 46px;
    margin-right: 40px;
    text-align: center;
    font-size: 14px;
    color: white;
  }

  .i18n-switch span {
    position: relative;
    display: inline-block;
    width: 30px;
    cursor: pointer;
  }

  .i18n-switch span:not(:last-child)::after {
    content: '';
    display: block;
    background: white;
    width: 1px;
    height: 20px;
    position: absolute;
    top: 14px;
    right: 0;
  }

  .domain-input-container {
    text-align: left;
  }

  .domain-input {
    width: 300px;
    display: inline-block;
  }

  .domain-input-button {
    display: inline-block;
  }

  .content {
    height: 100%;
  }

  .content-inner-container {
    background-color: #ffffff;
    box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
    color: #4a4a4a;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 1%;
    margin-bottom: 10px;
  }

  .inner-header {
    line-height: 1.2%;
    text-align: left;
    box-shadow: 0 1px 2px rgba(10, 10, 10, .1);
  }

  .inner-content {
    margin: 1% 3%;
    text-align: left;
  }

  .inner-content-left {
    display: inline-block;
    width: 20%;
  }

  .content-container {
    box-sizing: border-box;
    width: 70%;
    padding: 0;
    margin: 0 auto;
  }

  .inner-header-content {
    margin: 2% 3%;
    font-weight: bold;
  }

  @media screen and (max-width: 534px) {
    .domain-input {
      width: 70%;
      text-align: left;
    }
  }

  @media screen and (max-width: 500px) {
    .content-container {
      box-sizing: border-box;
      width: 90%;
      padding: 0;
      margin: 0 auto;
      font-size: small;
    }
  }

  @media screen and (max-width: 500px) {
    .inner-header-content {
      margin: 5% 3%;
    }
  }

  @media screen and (max-width: 340px) {
    .inner-content-left {
      width: auto;
    }
  }

  .foot {
    background-color: #ffffff;
    height: 100px;
    width: 100%;
  }

  .copyright-container {
    display: inline-block;
    margin-top: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue